import React, { PureComponent } from "react";

import AUTO_CLICKERS_DATA from "./auto-clicker-data.js";
import AutoClicker from "./AutoClicker.jsx";
import InstantWinPanel from './InstantWinPanel.jsx'
import helpers from "./helpers.js";
import "./App.css";

// LOL DOC
// https://blog.kongregate.com/the-math-of-idle-games-part-i/
// https://gamedevelopment.tutsplus.com/articles/numbers-getting-bigger-the-design-and-math-of-incremental-games--cms-24023

class App extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      theNumber: 0,
      theRate: 0.05,
      didInstantWin: false
    };

    this.autoClickersRefs = AUTO_CLICKERS_DATA.map(_ => React.createRef());

    this.last_ts = -1;
    window.requestAnimationFrame(this.doTick);
  }

  doTick = ts => {
    const { theNumber, theRate } = this.state;
    if (this.last_ts > 0) {
      const dms = ts - this.last_ts;
      const ds = dms / 1000;
      this.setState({
        theNumber: theNumber + theRate * ds
      });
    }

    this.last_ts = ts;
    window.requestAnimationFrame(this.doTick);
  };

  getCurrentRate = () => {
    // Base rate + auto-clickers rate
    const { didInstantWin, theRate } = this.state;

    if (didInstantWin) {
      return 0;
    }

    let sum = 0;
    sum += theRate;
    this.autoClickersRefs.forEach((acRef, idx) => {
      if (
        acRef.current &&
        acRef.current.isUnlocked &&
        acRef.current.isAutomated
      ) {
        sum +=
          acRef.current.isUnlocked() && acRef.current.isAutomated()
            ? acRef.current.getCurrentIncome() /
              AUTO_CLICKERS_DATA[idx].waitTime
            : 0;
      }
    });
    return sum;
  };

  doInstantWin = () => {
    this.setState(
      {
        didInstantWin: true,
        theNumber: 999999999999.99,
        theRate: 0
      },
      () => {
        alert("You have won!\nI'm so proud of you.");
      }
    );
  };

  onIncrementNumber = incrementValue => {
    const { didInstantWin, theNumber } = this.state;

    if (didInstantWin) {
      return;
    }

    const newValue = theNumber + incrementValue;
    if (newValue > 0) {
      this.setState(state => ({ theNumber: state.theNumber + incrementValue }));
    }
  };

  render() {
    const { didInstantWin, theNumber } = this.state;

    return (
      <React.Fragment>
        <section id="section-dashboard">
          <div className="info-card">
            <span className="card-label">Number is</span>
            <span className="card-value" id="the-number">
              {helpers.prettyPrintNumber(theNumber)}
            </span>
          </div>
          <div className="info-card">
            <span className="card-label">Rate is</span>
            <span className="card-value" id="the-rate">
              {helpers.prettyPrintNumber(this.getCurrentRate())}
            </span>
            <span className="card-footer">per second</span>
          </div>
        </section>

        <h3>Helpers</h3>
        <section id="section-controls">
          <ul id="upgrade-list">
            {AUTO_CLICKERS_DATA.map((data, idx) => (
              <AutoClicker
                key={data.name}
                ref={this.autoClickersRefs[idx]}
                name={data.name}
                unlockCost={data.unlockCost}
                currentNumber={theNumber}
                incrementNumber={this.onIncrementNumber}
                forceInvisible={didInstantWin}
                automateCost={data.automateCost}
                incomeBaseline={data.incomeBaseline}
                incomeMultiplier={data.incomeMultiplier}
                costBaseline={data.costBaseline}
                costMultiplier={data.costMultiplier}
                waitTime={data.waitTime}
              />
            ))}
          </ul>
        </section>
        {!didInstantWin ? (
          <InstantWinPanel onInstantWin={this.doInstantWin} />
        ) : null}
        <footer>
          <h3>Credits</h3>

          <section>
            A game by{" "}
            <a
              href="https://github.com/tchapeaux"
              target="_blank"
              title="Author's Github page"
            >
              tchapeaux
            </a>{" "}
            hosted on{" "}
            <a href="https://www.glitch.com" target="_blank">
              Glitch
            </a>
            .
          </section>
        </footer>
      </React.Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js